import axios from "./config/axios"

export const userAuthentication = async (token: string) =>
	await axios.get("/auth/access", {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
